import { useTranslation } from 'react-i18next';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { useLocale } from '../i18n';
import { homePath } from '../seo/routes';

export const NotFound = () => {
  const { t } = useTranslation();
  const locale = useLocale();

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <main className="max-w-content mx-auto flex flex-col items-center px-4 py-32 text-center sm:px-6 lg:px-8">
        <p className="eyebrow mb-4 text-primary">{t('notFound.eyebrow')}</p>
        <h1 className="mb-6 font-display text-5xl font-extrabold md:text-6xl">
          {t('notFound.title')}<span className="text-primary">.</span>
        </h1>
        <p className="mb-8 max-w-md text-muted-foreground">{t('notFound.body')}</p>
        <a href={homePath(locale)} className="btn-primary">
          {t('notFound.cta')}
        </a>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
